import { AbstractControl } from '@angular/forms';
import { AppSettings } from '../settings/app.settings';

declare var adyen;
export class CardValidator {

    static Correct(group: AbstractControl) {
        /**
         * cardHolderName: ["",Validators.required],
          cardNumber: ["",Validators.required],
          cardExpiryMonth: ["",CustomSelectValidator.required],
          cardExpiryYear: ["",CustomSelectValidator.required],
          cardCvc: ["",Validators.required]
         */
        
        if(!group.get("withCredit").value){
            let card:any = {};
            card['holderName'] = group.get("cardHolderName").value;
            card['number'] = `${group.get("cardNumber").value}`;
            card['generationtime'] = new Date(group.get("generationTime").value).toISOString();
            card['expiryMonth'] = group.get("dates").get("cardExpiryMonth").value.name;
            card['expiryYear'] = `${group.get("dates").get("cardExpiryYear").value.name}`;
            card['cvc'] = `${group.get("cardCvc").value}`;
            if(card['cvc'] == ""){
                delete card['cvc'];
            }

            var cseInstance = adyen.encrypt.createEncryption(AppSettings.ADYEN_KEY, {});
            let encryptedCard = cseInstance.encrypt(card);
            group.get("encryptedCard").setValue(encryptedCard);

            if(encryptedCard)
                return true;
            else{
                group.get("cardNumber").setErrors({cardError:true}); 
            }

        }else{
            group.get("encryptedCard").setValue(true);
            return true;
        }
    }
}